import React from 'react';
import { useNavigate } from 'react-router-dom';
import { solutionColors } from '../styles/solutions';
import ProductHero from '../components/ProductPage/ProductHero';
import FeaturesSection from '../components/ProductPage/FeaturesSection';
import BenefitsSection from '../components/ProductPage/BenefitsSection';
import CTASection from '../components/ProductPage/CTASection';
import {
  AIModelIcon,
  CustomModelIcon,
  TrainingIcon,
  DeployIcon,
  OptimizationIcon,
  AccuracyIcon,
  SpeedIcon,
  ScalabilityIcon,
} from '../components/ProductPage/icons';

const ModelosIAPage: React.FC = () => {
  const navigate = useNavigate();
  const color = solutionColors['modelos-ia'];

  const scrollToContact = () => {
    navigate('/contato');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const goToHome = () => {
    navigate('/');
    setTimeout(() => {
      const element = document.getElementById('solutions');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  const features = [
    {
      icon: <CustomModelIcon />,
      title: 'Modelos Personalizados',
      description: 'Desenvolvemos modelos de IA sob medida para as necessidades específicas do seu negócio, desde classificação até previsão e geração de conteúdo.',
    },
    {
      icon: <TrainingIcon />,
      title: 'Treinamento Especializado',
      description: 'Utilizamos seus dados históricos para treinar modelos altamente precisos, garantindo resultados alinhados com seus objetivos de negócio.',
    },
    {
      icon: <DeployIcon />,
      title: 'Deploy Simplificado',
      description: 'Do conceito à produção, cuidamos de toda a infraestrutura e deploy, garantindo modelos em operação de forma rápida e segura.',
    },
  ];

  const benefits = [
    {
      icon: <AccuracyIcon />,
      title: 'Alta Precisão',
      description: 'Modelos otimizados para seu domínio específico, alcançando taxas de acurácia superiores a modelos genéricos de mercado.',
    },
    {
      icon: <OptimizationIcon />,
      title: 'Otimização Contínua',
      description: 'Monitoramento ativo e retreinamento periódico para garantir que o modelo se mantenha preciso mesmo com mudanças nos dados.',
    },
    {
      icon: <SpeedIcon />,
      title: 'Inferência Rápida',
      description: 'Arquitetura otimizada para garantir respostas em tempo real, mesmo processando grandes volumes de dados.',
    },
    {
      icon: <ScalabilityIcon />,
      title: 'Escalabilidade Horizontal',
      description: 'Infraestrutura preparada para crescer conforme a demanda, sem comprometer performance ou disponibilidade.',
    },
  ];

  return (
    <>
      <ProductHero
        icon={<AIModelIcon />}
        title="<span class='highlight'>Modelos de IA</span><br />personalizados para o seu negócio"
        subtitle="Do conceito ao deploy, IA que entrega resultados reais"
        description="Criamos modelos de inteligência artificial sob medida, treinados especificamente para resolver seus desafios de negócio. Da análise preditiva à geração de insights, desenvolvemos soluções de IA que se integram perfeitamente aos seus processos e entregam resultados mensuráveis."
        color={color}
        onPrimaryClick={scrollToContact}
        primaryButtonText="Fale Conosco"
      />

      <FeaturesSection
        title="Desenvolvimento de ponta a ponta"
        subtitle="Cuidamos de todo o ciclo de vida do modelo de IA"
        features={features}
        color={color}
      />

      <BenefitsSection
        title="Vantagens competitivas mensuráveis"
        subtitle="IA que gera valor real para seu negócio"
        benefits={benefits}
        color={color}
      />

      <CTASection
        title="Transforme dados em vantagem competitiva"
        description="Converse com nossos especialistas em IA e descubra como modelos personalizados podem revolucionar seus processos de negócio."
        color={color}
        primaryButtonText="Agendar Conversa"
        secondaryButtonText="Ver Outras Soluções"
        onPrimaryClick={scrollToContact}
        onSecondaryClick={goToHome}
      />
    </>
  );
};

export default ModelosIAPage;


